<template>
    <div class="guide-page" :class="{'guide-page_decrease-margin':featureGuideFilterEnabled}">
        <guide/>
    </div>
</template>

<script setup lang="ts">
    import { nextTick, onMounted } from "vue";
    import Guide from "@/components/Guide/Guide.vue";
    import { ScreenName } from "@/common/types/screen-names";

    definePageMeta({
        middleware: ['fetch-guide'],
    });

    const { $analytics } = useNuxtApp();
    const { guideConfig } = useAppConfig();
    const featureGuideFilterEnabled = guideConfig.featureGuideFilterEnabled;

    onMounted(() => {
       void nextTick(() => {
            $analytics.createScreenEvent(ScreenName.GUIDE_PAGE, ScreenName.GUIDE_PAGE);
        });
    });
</script>

<style lang="scss">
    @import url("styles.scss");
</style>